export class Address {
	storageId: number;
	uuid: string;
	firstname: string;
	lastname: string;
	email: string;
	phoneNumber: string;
	street: string;
	houseNumber: string;
	city: string;
	postalCode: string;
	salutation: string;
	companyName: string;
	fullName: string;
	informalName: string;
	formalName: string;
}



// WEBPACK FOOTER //
// ./src/app/models/address.model.ts